import { getPaymentSummary, PaymentSummaryRequest } from "Hooks/Api/apiPayment";
import useAsync from "Hooks/useAsync";

export function useApiPaymentSummary({
	organisationId,
	services,
}: PaymentSummaryRequest) {
	const accessPaymentSummary = useAsync(async () => {
		const response = await getPaymentSummary({
			organisationId,
			services,
		});
		return response.data;
	}, [organisationId]);

	return accessPaymentSummary;
}